
    <template>
      <section class="content element-doc">
        <h2 id="input-shu-ru-kuang"><a class="header-anchor" href="#input-shu-ru-kuang">¶</a> Input 输入框</h2>
<p>基础属性和使用方法参考 <a href="https://element.eleme.cn/#/zh-CN/component/input">element-ui </a> <code>el-input</code> 组件文档</p>
<h3 id="ji-chu-yong-fa"><a class="header-anchor" href="#ji-chu-yong-fa">¶</a> 基础用法</h3>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;sh-input v-model=&quot;value&quot; /&gt;
&lt;/template&gt;

&lt;script&gt;
  export default {
    data() {
      return {
        value: ''
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="bu-ke-qing-kong"><a class="header-anchor" href="#bu-ke-qing-kong">¶</a> 不可清空</h3>
<demo-block>
        
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;sh-input v-model=&quot;value&quot; :clearable=&quot;false&quot; /&gt;
&lt;/template&gt;

&lt;script&gt;
  export default {
    data() {
      return {
        value: ''
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="shu-xing"><a class="header-anchor" href="#shu-xing">¶</a> 属性</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>clearable</td>
<td>是否可清空</td>
<td>boolean</td>
<td>-</td>
<td>true</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('sh-input',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        value: ''
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('sh-input',{attrs:{"clearable":false},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        value: ''
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  